module.exports = __webpack_public_path__ + "static/sf-2ce6efebc349564a00eb8ef149adba43.png";